export const TITLE = 'Request national exam fee reimbursement online';
export const SUBTITLE =
  'Request for reimbursement for national exam fee (VA Form 22-0810)';
export const OMB_RES_BURDEN = 15;
export const OMB_NUMBER = '2900-0706';
export const OMB_EXP_DATE = '01/31/2028';
